var productFormSelector = 'form[action*="cart/add"].product-buy-form-pdp';

function Elixir_ProductFormExists() {
    return document.querySelector(productFormSelector) !== null;
}

function Elixir_GetProductForm() {
    return document.querySelector(productFormSelector);
}

function Elixir_ProductFormHasItemsInputs() {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    return form.querySelector('input[name^="items["]') !== null;
}

// Returns the variant ID from the product form. In single-variant mode uses input[name="id"]; in items[] mode (e.g. Quantity Break) uses the first items[X][id] value so price/context use the correct variant.
function Elixir_GetProductFormVariantId() {
    var form = Elixir_GetProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    if (input && input.value) return input.value;
    if (Elixir_ProductFormHasItemsInputs()) {
        var firstId = form.querySelector('input[name^="items["][name*="][id]"]');
        if (firstId && firstId.value) return firstId.value;
    }
    return null;
}

// Returns the selling plan ID from the product form (input[name="selling_plan"]), or null if missing/empty.
function Elixir_GetProductFormSellingPlan() {
    var form = Elixir_GetProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="selling_plan"]');
    return input && input.value ? input.value : null;
}

// Sets the selling plan on the product form. Creates input[name="selling_plan"] if missing.
// Pass null, undefined or '' to clear (one-time purchase). Dispatches input and change events.
function Elixir_SetProductFormSellingPlan(sellingPlanId) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    var value = (sellingPlanId !== undefined && sellingPlanId !== null && sellingPlanId !== '') ? String(sellingPlanId) : '';
    var input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
    }
    input.value = value;
    input.setAttribute('value', value);
    input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
    return true;
}

function Elixir_SetProductFormVariantId(variantId) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    var input = form.querySelector('input[name="id"]');
    if (input) {
        input.value = variantId !== undefined && variantId !== null && variantId !== '' ? String(variantId) : '';
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    return true;
}

function Elixir_ProductFormSwitchToItemsMode(items, options) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    if (!items || !Array.isArray(items) || items.length === 0) return false;

    options = options || {};
    var containerClass = options.containerClass || 'product-form-items-container';
    var startIndex = options.startIndex !== undefined ? options.startIndex : 1;

    var existing = form.querySelector('.' + containerClass);
    if (existing) existing.remove();

    var container = document.createElement('div');
    container.className = containerClass;

    items.forEach(function (item, i) {
        var index = startIndex + i;
        var idIn = document.createElement('input');
        idIn.type = 'hidden';
        idIn.name = 'items[' + index + '][id]';
        idIn.value = String(item.id);
        idIn.className = 'product-variant-id';
        container.appendChild(idIn);

        var qtyIn = document.createElement('input');
        qtyIn.type = 'hidden';
        qtyIn.name = 'items[' + index + '][quantity]';
        qtyIn.value = String(item.quantity != null ? item.quantity : 1);
        container.appendChild(qtyIn);

        if (item.selling_plan != null && item.selling_plan !== '') {
            var planIn = document.createElement('input');
            planIn.type = 'hidden';
            planIn.name = 'items[' + index + '][selling_plan]';
            planIn.value = String(item.selling_plan);
            container.appendChild(planIn);
        }

        if (item.properties && typeof item.properties === 'object') {
            Object.keys(item.properties).forEach(function (key) {
                var propIn = document.createElement('input');
                propIn.type = 'hidden';
                propIn.name = 'items[' + index + '][properties][' + key + ']';
                propIn.value = String(item.properties[key]);
                container.appendChild(propIn);
            });
        }
    });

    var mainIdInput = form.querySelector('input[name="id"]');
    if (mainIdInput) mainIdInput.remove();

    form.appendChild(container);
    return true;
}

function Elixir_ProductFormSwitchToSingleIdMode(variantId, itemsContainerSelector) {
    var form = Elixir_GetProductForm();
    if (!form) return false;

    if (itemsContainerSelector) {
        var container = form.querySelector(itemsContainerSelector);
        if (container && (variantId === undefined || variantId === null || variantId === '')) {
            var firstIdInput = container.querySelector('input[name^="items["][name*="][id]"]');
            if (firstIdInput && firstIdInput.value) variantId = firstIdInput.value;
        }
        if (container) container.remove();
    }

    var input = form.querySelector('input[name="id"]');
    if (input) {
        if (variantId !== undefined && variantId !== null && variantId !== '') input.value = String(variantId);
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    return true;
}

function Elixir_InitProductFormQuantityListener() {
    document.addEventListener('change', function (e) {
        if (!e.target || e.target.name !== 'quantity') return;
        var form = Elixir_GetProductForm();
        if (!form || !form.contains(e.target)) return;
        var qty = parseInt(e.target.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        document.dispatchEvent(new CustomEvent('quantity:changed', {
            bubbles: true,
            detail: { quantity: qty }
        }));
    });
}

// SafeWalk's package and AJAX form controllers are deferred, while this small
// controller is loaded before the product form markup. Hold an unusually fast
// submit until both deferred controllers own the form so the selected add-ons
// and free gift cannot be skipped by a native /cart submission.
function Elixir_InitFourPawSafeWalkSubmitGuard() {
    var pendingForms = new WeakMap();
    var readinessTimeout = 15000;

    function getControllers(form) {
        var section = form && form.closest
            ? form.closest('.shop-product-section')
            : null;
        var productForm = form && form.closest ? form.closest('product-form') : null;
        var formId = form && form.getAttribute ? form.getAttribute('id') : '';
        if (!section || !productForm || !formId) return null;

        var packageSelector = null;
        var candidates = section.querySelectorAll('fourpaw-package-selector');
        for (var index = 0; index < candidates.length; index += 1) {
            if (candidates[index].getAttribute('data-product-form-id') === formId) {
                packageSelector = candidates[index];
                break;
            }
        }
        if (!packageSelector) return null;

        return {
            productForm: productForm,
            packageSelector: packageSelector
        };
    }

    function controllersOwnForm(form) {
        var controllers = getControllers(form);
        return Boolean(
            controllers &&
            controllers.productForm &&
            controllers.productForm.form === form &&
            controllers.productForm.submitButton &&
            typeof controllers.productForm.onSubmitHandler === 'function' &&
            controllers.packageSelector &&
            controllers.packageSelector.boundForm === form &&
            typeof controllers.packageSelector.prepareSubmit === 'function'
        );
    }

    function setPendingState(pending, isPending) {
        var button = pending.submitter;
        if (!button) return;

        var spinner = button.querySelector
            ? button.querySelector('.loading__spinner')
            : null;
        if (isPending) {
            button.setAttribute('aria-busy', 'true');
            if (button.classList) button.classList.add('loading');
            if (spinner && spinner.classList) spinner.classList.remove('hidden');
            return;
        }

        button.removeAttribute('aria-busy');
        if (button.classList) button.classList.remove('loading');
        if (spinner && spinner.classList) spinner.classList.add('hidden');
    }

    function showRetryError(form) {
        var productForm = form && form.closest ? form.closest('product-form') : null;
        var wrapper = productForm && productForm.querySelector
            ? productForm.querySelector('.product-form__error-message-wrapper')
            : null;
        var message = wrapper && wrapper.querySelector
            ? wrapper.querySelector('.product-form__error-message')
            : null;
        if (message) {
            message.textContent = (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';
        }
        if (wrapper) wrapper.hidden = false;
    }

    function finishPending(form, pending) {
        if (pendingForms.get(form) !== pending) return false;
        pendingForms.delete(form);
        setPendingState(pending, false);
        return true;
    }

    function resumeWhenReady(form, pending) {
        if (pendingForms.get(form) !== pending) return;
        if (form.isConnected === false) {
            finishPending(form, pending);
            return;
        }

        var submitter = pending.submitter;
        if (!submitter || submitter.isConnected === false || submitter.form !== form) {
            submitter = form.querySelector('[type="submit"][name="add"], [type="submit"]');
            pending.submitter = submitter;
        }

        if (
            controllersOwnForm(form) &&
            submitter &&
            !submitter.disabled &&
            submitter.getAttribute('aria-disabled') !== 'true'
        ) {
            if (!finishPending(form, pending)) return;
            window.setTimeout(function () {
                if (form.isConnected === false) return;
                try {
                    form.requestSubmit(submitter);
                } catch (error) {
                    showRetryError(form);
                    console.error('Unable to resume the SafeWalk add to cart:', error);
                }
            }, 0);
            return;
        }

        if (Date.now() - pending.startedAt >= readinessTimeout) {
            finishPending(form, pending);
            showRetryError(form);
            return;
        }

        pending.timer = window.setTimeout(function () {
            resumeWhenReady(form, pending);
        }, 25);
    }

    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!getControllers(form)) return;

        var existing = pendingForms.get(form);
        if (existing) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }
        if (controllersOwnForm(form)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        var pending = {
            startedAt: Date.now(),
            submitter: event.submitter || form.querySelector('[type="submit"][name="add"], [type="submit"]'),
            timer: null
        };
        pendingForms.set(form, pending);
        setPendingState(pending, true);
        resumeWhenReady(form, pending);
    }, true);
}

Elixir_InitProductFormQuantityListener();
Elixir_InitFourPawSafeWalkSubmitGuard();
